<template>
  <div class="material">
     <div class="content-container" >
      <div class="titieMian">
        <div class="title-container">物资设置</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>在&nbsp;&nbsp;</span>
            <el-select v-model="type" filterable placeholder="请选择" size="small" @change="typelistdata">
              <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.id" >
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>查找&nbsp;&nbsp;</span>
            <el-input placeholder="请输入关键字" v-model="keyword" prefix-icon="el-icon-search" size="small" type="text" :maxlength="20" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" class="search-input" clearable>
            </el-input>
          </div>
          <div class="select-container-box"  v-if="canEditAll=true">
            <el-button size="small" type="info" plain @click="goSearch(1)" class="query" >查询</el-button>
            <el-button size="small" type="info" plain @click="goAdd" class="add" v-if="edit">增加</el-button>
            <!-- <el-button size="small" type="info" plain @click="goSync" class="tongbu" v-if="$store.state.curCompany.isQlwVersion==true&&edit">同步</el-button> -->
             
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table
          :data="materialSettingList.list"
          @row-dblclick="dataBackFillGoods"
          style="width:100%" 
          size="medium" 
          :default-sort="{prop: 'date', order: 'descending'}">
           <i slot="empty" style="font-style:normal">暂无数据</i>
          <el-table-column
           prop="category" 
           label="物资大类"
           :filters="getFilterTypeList"
           :filter-method="filterHandler" 
           align="center"
           show-overflow-tooltip 
          >
          </el-table-column>
          <el-table-column 
          prop="type" 
          :filters="getFilterTypesList"
          :filter-method="filterHandler" 
          label="物资类型" 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="name" 
          label="物资名称" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
         
          <el-table-column 
          prop="spec" 
          label="规格" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
           <el-table-column 
          prop="unit" 
          label="计量单位" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
          <el-table-column label="操作栏" align="center"  >
            <template slot-scope="scope">
              <span @click="baseSettingEdit(scope.$index, scope.row)" class="content-edit" >{{edit ? '编辑' : '查看'}}</span>
              <span @click="baseSettingDelete(scope.$index, scope.row)" class="content-del" v-if="edit">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
      <dialog-component @updatelist="updateList" :class="{isShow:editObj.isShow}" :dialogObj = "dialogObj"></dialog-component>
    </div>
  </div>
</template>


<script>
import { MessageBox, Message } from "element-ui";
import PageChange from "../../common/PageChange";
import { mapActions, mapState, mapMutations } from "vuex";
import { modules } from "../../../store";
import DialogComponent from "./DialogComponent";
import checkPermission from "../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "materialSetting",
  mixins: [mixins],
  components: {
    PageChange,
    DialogComponent
  },
  data() {
    return {
      dialogObj: {
        id: "",
        category: "",
        titleName: "添加物资信息",
        dialogFormVisible: false,
        width: "600px"
      },
      form: {
        name: "", //费用名称
        unit: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请先选择养殖品种",
            trigger: "blur"
          }
        ],
        unit: [
          {
            required: true,
            message: "请先选择计量单位",
            trigger: "blur"
          }
        ]
      },
      formLabelWidth: "80px",
      typeList: [
        {
          name: "全部",
          id: ""
        },
        {
          name: "饲料",
          id: 10001
        },
        {
          name: "渔药",
          id: 10002
        },
        {
          name: "疫苗",
          id: 10003
        },
        {
          name: "渔肥",
          id: 10004
        }
      ],
      type: "全部",
      typeId: "",
      keyword: "", // 关键字
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.goSearch, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      }
    };
  },
  computed: {
    ...mapState(modules.materialSetting, [
      "materialSettingList",
      "dialogFormVisible",
      "editObj"
    ]),
    //需要筛选的字段
    getFilterTypeList() {
      const res = new Map();
      let fiterList = this.materialSettingList.list
        .map(m => ({
          value: m.category,
          text: m.category
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    //需要筛选的字段
    getFilterTypesList() {
      const res = new Map();
      let fiterList = this.materialSettingList.list
        .map(m => ({
          value: m.type,
          text: m.type
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    }
  },
  mounted() {
    this.goSearch(1);
  },
  methods: {
    ...mapActions(modules.dataDict, ["getMeasurementUnit"]), //计量单位
    ...mapActions(modules.materialSetting, [
      "getMaterialSettingData", //查询
      "delMaterialSettingList", //删除
      "addMaterialSetting", //添加
      "syncMaterials" //同步
    ]),
    ...mapMutations(modules.materialSetting, [
      "setDialogFormVisible",
      "setDialogObj"
    ]),
    // 字段筛选过滤
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    updateList() {
      if (this.editObj.isShow) {
        this.goSearch(Number(localStorage.getItem("pageNumber")));
      } else {
        this.goSearch(1);
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    //类型切换
    typelistdata(val) {
      this.typeId = val;
      this.goSearch(1);
    },
    //查询
    async goSearch(pageNum) {
      let obj = {
        pageIndex: (this.pageInfo.pageNumber = pageNum || 1),
        pageSize: this.pageInfo.pageSize,
        fishStockAbstract: this.typeId,
        queryString: this.keyword
      };

      this.getMaterialSettingData(obj)
        .then(rsp => {
          if (rsp.status === 200) {
            this.pageInfo.totalPages = rsp.data.total;
          }
        })
        .catch(err => {
          console.dir(err);
        });
    },
    //同步
    goSync() {
      this.syncMaterials()
        .then(rsp => {
          if (rsp.status == 200) {
            this.$message({
              message: "同步成功",
              type: "success"
            });
            this.goSearch();
          }
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
          // console.dir(err.response.data);
        });
    },
    // 添加
    goAdd() {
      // this.dialogObj.dialogFormVisible = true;
      this.setDialogFormVisible(true);
      console.log(111222, this.titleName);

      this.dialogObj.titleName = "添加物资信息";
      this.form.name = "";
      this.setDialogObj({
        id: "",
        category: "",
        active: "first",
        isShow: false,
        edit: this.edit
      });
    },
    //双击进去编辑页
    dataBackFillGoods(row, event) {
      this.setDialogFormVisible(true);
      this.dialogObj.id = row.id;
      this.dialogObj.category = row.category;
      let active = "";
      if (row.category == "饲料") {
        active = "first";
        if (this.$store.state.curCompany.isQlwVersion == true) {
          this.dialogObj.titleName = "编辑饲料信息";
        } else if (
          this.$store.state.curCompany.isQlwVersion == false &&
          this.edit == true
        ) {
          this.dialogObj.titleName = "编辑饲料信息";
        } else if (
          this.$store.state.curCompany.isQlwVersion == false &&
          this.edit == false
        ) {
          this.dialogObj.titleName = "查看饲料信息";
        }
      } else if (row.category == "渔药") {
        active = "second";
        if (this.$store.state.curCompany.isQlwVersion == true) {
          this.dialogObj.titleName = "编辑渔药信息";
        } else if (
          this.$store.state.curCompany.isQlwVersion == false &&
          this.edit == true
        ) {
          this.dialogObj.titleName = "编辑渔药信息";
        } else if (
          this.$store.state.curCompany.isQlwVersion == false &&
          this.edit == false
        ) {
          this.dialogObj.titleName = "查看渔药信息";
        }
      } else if (row.category == "疫苗") {
        active = "third";
        if (this.$store.state.curCompany.isQlwVersion == true) {
          this.dialogObj.titleName = "编辑疫苗信息";
        } else if (
          this.$store.state.curCompany.isQlwVersion == false &&
          this.edit == true
        ) {
          this.dialogObj.titleName = "编辑疫苗信息";
        } else if (
          this.$store.state.curCompany.isQlwVersion == false &&
          this.edit == false
        ) {
          this.dialogObj.titleName = "查看疫苗信息";
        }
      } else if (row.category == "渔肥") {
        active = "fourth";
        if (this.$store.state.curCompany.isQlwVersion == true) {
          this.dialogObj.titleName = "编辑渔肥信息";
        } else if (
          this.$store.state.curCompany.isQlwVersion == false &&
          this.edit == true
        ) {
          this.dialogObj.titleName = "编辑渔肥信息";
        } else if (
          this.$store.state.curCompany.isQlwVersion == false &&
          this.edit == false
        ) {
          this.dialogObj.titleName = "查看渔肥信息";
        }
      }
      this.setDialogObj({
        id: row.id,
        category: row.category,
        active: active,
        isShow: true,
        edit: this.edit
      });
    },
    //编辑
    baseSettingEdit(index, row) {
      console.log(row, 111);
      this.setDialogFormVisible(true);
      this.dialogObj.id = row.id;
      this.dialogObj.category = row.category;
      let active = "";
      if (row.category == "饲料") {
        active = "first";
        if (this.$store.state.curCompany.isQlwVersion == true) {
          this.dialogObj.titleName = "编辑饲料信息";
        } else if (
          this.$store.state.curCompany.isQlwVersion == false &&
          this.edit == true
        ) {
          this.dialogObj.titleName = "编辑饲料信息";
        } else if (
          this.$store.state.curCompany.isQlwVersion == false &&
          this.edit == false
        ) {
          this.dialogObj.titleName = "查看饲料信息";
        }
      } else if (row.category == "渔药") {
        active = "second";
        if (this.$store.state.curCompany.isQlwVersion == true) {
          this.dialogObj.titleName = "编辑渔药信息";
        } else if (
          this.$store.state.curCompany.isQlwVersion == false &&
          this.edit == true
        ) {
          this.dialogObj.titleName = "编辑渔药信息";
        } else if (
          this.$store.state.curCompany.isQlwVersion == false &&
          this.edit == false
        ) {
          this.dialogObj.titleName = "查看渔药信息";
        }
      } else if (row.category == "疫苗") {
        active = "third";
        if (this.$store.state.curCompany.isQlwVersion == true) {
          this.dialogObj.titleName = "编辑疫苗信息";
        } else if (
          this.$store.state.curCompany.isQlwVersion == false &&
          this.edit == true
        ) {
          this.dialogObj.titleName = "编辑疫苗信息";
        } else if (
          this.$store.state.curCompany.isQlwVersion == false &&
          this.edit == false
        ) {
          this.dialogObj.titleName = "查看疫苗信息";
        }
      } else if (row.category == "渔肥") {
        console.log(row, 222);
        active = "fourth";
        if (this.$store.state.curCompany.isQlwVersion == true) {
          this.dialogObj.titleName = "编辑渔肥信息";
        } else if (
          this.$store.state.curCompany.isQlwVersion == false &&
          this.edit == true
        ) {
          this.dialogObj.titleName = "编辑渔肥信息";
        } else if (
          this.$store.state.curCompany.isQlwVersion == false &&
          this.edit == false
        ) {
          this.dialogObj.titleName = "查看渔肥信息";
        }
      }
      this.setDialogObj({
        id: row.id,
        category: row.category,
        active: active,
        isShow: true,
        edit: this.edit
      });
    },
    //取消
    cancel(formName) {
      this.$refs[formName].resetFields();
      this.setDialogFormVisible(false);
      this.form.name = "";
    },
    //删除
    baseSettingDelete(index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await this.delMaterialSettingList(row.id);
          this.goSearch(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(err => {
          // console.log(err);
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error(err.response.data);
        });
    }
  }
};
</script>
<style lang="stylus">
.material
  .isShow
    .el-tabs__header
      display:none
</style>
